module.exports = {
          srcSet: __webpack_public_path__ + "images/2000-adf551c26d4a7b73c119a2d2f9c63a9a-320.jpg"+" 320w"+","+__webpack_public_path__ + "images/2000-5db27deebdcafe6f431ec209882494ab-370.jpg"+" 370w",
          images:[ {path: __webpack_public_path__ + "images/2000-adf551c26d4a7b73c119a2d2f9c63a9a-320.jpg",width: 320,height: 251},{path: __webpack_public_path__ + "images/2000-5db27deebdcafe6f431ec209882494ab-370.jpg",width: 370,height: 290}],
          src: __webpack_public_path__ + "images/2000-adf551c26d4a7b73c119a2d2f9c63a9a-320.jpg",
          toString:function(){return __webpack_public_path__ + "images/2000-adf551c26d4a7b73c119a2d2f9c63a9a-320.jpg"},
          
          width: 320,
          height: 251
        }